import MaintenancePage from '@/pages/manufacturing/maintenance/page';

export default function MaintenanceSchedulesWrapper() {
  return <MaintenancePage initialTab="schedules" />;
}